import { useContext } from 'react';
import { ConferenceConfigurationsCtx } from 'calls/ConferenceConfigurationsProvider.jsx';

const useConferenceConfigurations = () => {
	return useContext(ConferenceConfigurationsCtx);
};

export default useConferenceConfigurations;
